<template>
  <div class="row">
    <div class="small-12 columns">
      <div class="row">
        <h1>Add Language</h1>
        <div class="small-3 columns">Language</div>
        <div class="small-9 columns">
          <input
            v-model="language"
            type="text"
            class="input-box-course-creators"
          />
        </div>
        <div class="small-3 columns">JZ COde</div>
        <div class="small-9 columns">
          <input
            v-model="jzcode"
            type="text"
            class="input-box-course-creators"
          />
        </div>
      </div>
    </div>
    <div class="small-12 columns">
      <button class="button-blue" @click="editLanguage">Add Language</button>
    </div>
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"

export default {
  data() {
    return {
      language: undefined,
      jzcode: undefined,
    }
  },
  mounted() {
    this.axios({
      method: "get",
      url: `${siteConfig.siteURL}languages/${this.$route.params.id}`,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-access-token": localStorage.token,
      },
    }).then(res => {
      this.language = res.data.name
      window.pageTitle = `Edit - ${this.language}`
      this.jzcode = res.data.jz_code
    })
  },
  methods: {
    editLanguage() {
      this.axios({
        method: "put",
        url: `${siteConfig.siteURL}languages/${this.$route.params.id}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
        data: { name: this.language, jz_code: this.jzcode },
      }).then(() => {
        this.$router.push("/language/")
      })
    },
  },
}
</script>
